export enum GAMetric {
    NumberOfPriceLevels = 'metric1',
    NumberOfEvents = 'metric2',
}
